import React from 'react';
import moment from 'moment';
import ResendAction from './ResendAction';
import CancelAction from '../../../Schedule/Component/Actions/CancelAction';
import RescheduleAction from '../../../Schedule/Component/Actions/RescheduleAction';

export default function SentActions({ type, date, eventId, eventItem, rescheduleItem, cancelHandler }) {
  return <div>
    <ResendAction eventId={eventId} eventItem={eventItem} />
    &nbsp;
    <RescheduleAction
      type={type}
      date={date}
      eventItem={eventItem}
      eventDoctor={{ value: eventItem.doctor.id, label: `${eventItem.providerGroup.firstName} ${eventItem.providerGroup.lastName}` }}
      eventProvider={{ value: eventItem.providerGroup.id, label: eventItem.name }}
      rescheduleItem={rescheduleItem}
      eventAvailableOn={eventItem.availableOn && eventItem.availableOn.date ? moment(eventItem.availableOn.date).toDate() : null}
    />
    &nbsp;
    <CancelAction type={type} cancelEventItem={() => {
      cancelHandler(eventItem)
    }} />
  </div>
}